
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/legal-disclaimer",
      function () {
        return require("private-next-pages/terms/legal-disclaimer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/legal-disclaimer"])
      });
    }
  